import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { dataLayer } from '@weatherbug/common';
const _logEvent = dataLayer.actions.logEvent;
import { connect } from 'react-redux';

export function withLogging(WrappedComponent) {
    const wrappedComponentName = WrappedComponent.displayName
        || WrappedComponent.name
        || 'Component';

    const mapStoreStateToProps = () => {
        return {};
    };

    const mapDispatchToProps = {
        _logEvent
    };

    const renderedComponent = connect(mapStoreStateToProps, mapDispatchToProps)(
        class Logger extends Component {
            static displayName = `withLogging(${wrappedComponentName})`;

            static propTypes = {
                appInstanceId: PropTypes.string
                , _logEvent: PropTypes.func.isRequired
                , stdParameters: PropTypes.object
                , loggingBaseUrl: PropTypes.string
                , authId: PropTypes.string
                , secret: PropTypes.string
            };

            constructor(props) {
                super(props);
                this.logEvent = this.logEvent.bind(this);
            }

            logEvent(eventType, data) {
                const { appInstanceId, stdParameters, loggingBaseUrl, authId, secret } = this.props;
                this.props._logEvent(
                    loggingBaseUrl
                    , authId
                    , secret
                    , eventType
                    , { deviceid: appInstanceId }
                    , data
                    , stdParameters
                );
            }

            render() {
                const { ...wrappedComponentProps } = this.props;
                return <WrappedComponent logEvent={this.logEvent} {...wrappedComponentProps} />;
            }
        }
    );

    renderedComponent.displayName = `withLogging(${wrappedComponentName})`;

    return renderedComponent;
}
